import styled from "styled-components";

import github from "../assets/icons/github.png";
import logo from "../assets/icons/logo.png";
import bmcLogo from "../assets/icons/bmc-logo-yellow.png";

const StyledHeader = styled.header`
  height: 60px;
  border-bottom: 1px solid #ebeff3;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  width: 100%;
  padding: 0px 20px;
`;

const Logo = styled.img`
  height: 20px;
`;

const Github = styled.img`
  height: 30px;
`;

const BuyMeACoffee = styled.button`
  padding: 4px 10px;
  background-color: #ffdd03;
  color: white;
  border-radius: 4px;
  color: #252525;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const Header = () => {
  // const [star, setStar] = useState<undefined | number>();

  // useEffect(() => {
  //   fetch("https://api.github.com/repos/Intosoft/qrcode")
  //     .then((data) => data.json())
  //     .then((data) => {
  //       setStar(data.stargazers_count);
  //     });
  // }, []);
  return (
    <StyledHeader>
      <Content>
        <a
          href="/"
          style={{
            paddingTop: 12,
          }}
        >
          <Logo src={logo} alt="Intosoft logo" />
        </a>

        <div
          style={{
            display: "flex",
          }}
        >
          <a
            href="https://github.com/Intosoft/qrcode"
            target="_blank"
            rel="noreferrer"
            style={{
              marginRight: 12,
              marginTop: 4,
            }}
          >
            <Github src={github} alt="Github logo" />
          </a>
          <a
            href="https://www.buymeacoffee.com/sakulbudhathoki"
            target="_blank"
            rel="noreferrer"
          >
            <BuyMeACoffee>
              <img
                src={bmcLogo}
                alt="Buy me a coffee"
                style={{
                  height: 30,
                }}
              />
              Buy me a coffee
            </BuyMeACoffee>
          </a>
        </div>
      </Content>
    </StyledHeader>
  );
};
